export default "__VITE_ASSET__CpwSNYhH__"